import { useSyncExternalStore } from 'react'
import { RoomEvent } from '../../constants/enums'
import { getActiveRooms } from '../../mfcLogic/rooms'
import { getRoomsState } from '../../state/getState'
import { pubSubRooms } from '../../state/pubSub'
import { subRoom } from './useRoom'

const getRooms = () => getRoomsState()
const subRooms = (callback: () => void) =>
    pubSubRooms.on(RoomEvent.STATE, callback)
const getRoomsCount = () => getActiveRooms(getRoomsState()).length

export const useRooms = () => {
    return useSyncExternalStore(subRooms, getRooms, getRooms)
}

export const useRoomsCount = (): number => {
    return useSyncExternalStore(subRoom, getRoomsCount, getRoomsCount)
}
